import * as React from "react";
import "./Header.css";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Avatar,
} from "@mui/material";
import APIAxios from "../../Api/APIAxios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "antd";
import { format } from "date-fns";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MoreIcon from "@mui/icons-material/MoreVert";
import SessaoAuth from "../../Hooks/SessaoAuth";
import dayjs from "dayjs";
import "antd/es/style/reset.css";

const { RangePicker } = DatePicker;

export default function Topo() {
  const logoImg = new URL("../../assets/brisiq_vision_bt.png", import.meta.url).href;

  const { sessao, setSessao } = SessaoAuth();
  const apiAxios = APIAxios();


  const [avatarUrl, setAvatarUrl] = useState(null);

  const carregarAvatarHeader = async (id) => {
    try {
      // Usando o axios diretamente como você sugeriu
      const response = await apiAxios.get(`/usuario/avatar/${id}`, {
        responseType: "blob",
      });

      if (response.data) {
        const url = URL.createObjectURL(response.data);
        setAvatarUrl(url);
      }
    } catch (err) {
      console.error("Erro ao carregar avatar no topo:", err);
    }
  };

  useEffect(() => {
    if (sessao?.authToken?.idUsuario) {
      carregarAvatarHeader(sessao.authToken.idUsuario);
    }
  }, [sessao?.authToken?.idUsuario]);

  {/*const fetchMensagensAbertas = async (event) => {
    setQtdMensagens(1);
    setQtdAvisos(2);
  };*/}

  {/*useEffect(() => {
    fetchMensagensAbertas();

    // Atualizar dados a cada 10 segundos
    const intervalo = setInterval(fetchMensagensAbertas, 10000);

    // Limpar intervalo ao desmontar o componente
    return () => clearInterval(intervalo);
  }, []);*/}

  // Outros
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const [confirmarSair, setConfirmarSair] = useState(false);

  const navigate = useNavigate();

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const handleSairConf = () => {
    setConfirmarSair(false);
    setSessao({});
    navigate("/login");
  };

  const handleSairCanc = () => {
    setConfirmarSair(false);
  };

  const handleSair = () => {
    setConfirmarSair(true);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

    const handleMinhaConta = () => {
    setAnchorEl(null);
    navigate("conta")
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMinhaConta}>Minha conta</MenuItem>
      <MenuItem onClick={handleSair}>Sair</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleMinhaConta}>Minha conta</MenuItem>
      <MenuItem onClick={handleSair}>Sair</MenuItem>
    </Menu>
  );

  const handleRangeChange = (dates) => {
    if (dates) {
      const [startDate, endDate] = dates;
      setSessao((prev) => ({
        ...prev,
        dataIni: format(startDate.toDate(), "dd/MM/yyyy"), // Converte para DD/MM/YYYY
        dataFim: format(endDate.toDate(), "dd/MM/yyyy"), // Converte para DD/MM/YYYY
      }));
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Dialog
        open={confirmarSair}
        onClose={handleSairCanc}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Deseja sair do sistema?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Caso você confirme, voltará para a tela de identificação.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSairCanc}>Cancelar</Button>
          <Button onClick={handleSairConf} autoFocus>
            Sair
          </Button>
        </DialogActions>
      </Dialog>

      <AppBar
        position="static"
        sx={{
          bgcolor: "#1a3865",
        }}
      >
        <Toolbar>
          <img src={logoImg} alt="Logo" style={{ height: "3em" }} />
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mr: { xs: 0, sm: "30px" },
                ml: { xs: "18px" },
              }}
            >
              <RangePicker
                className="faro-style-rangepicker"
                popupClassName={isMobile ? "rangepicker-mobile" : ""}
                value={[
                  sessao.dataIni ? dayjs(sessao.dataIni, "DD/MM/YYYY") : null,
                  sessao.dataFim ? dayjs(sessao.dataFim, "DD/MM/YYYY") : null,
                ]}
                separator="-"
                size="small"
                onChange={handleRangeChange}
                format="DD/MM/YYYY"
                placeholder={["Início", "Fim"]}

              />
            </Box>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
              sx={{
                display: { xs: "none", md: "flex" }, // esconde no mobile, mostra no desktop
              }}
            >
              <Avatar
                src={avatarUrl}
                sx={{ width: 35, height: 35, border: "1px solid #fff" }}
              >
                {/* Caso a imagem falhe ou não exista, mostra o ícone padrão como reserva */}
                {!avatarUrl && <AccountCircle />}
              </Avatar>
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
}
